/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Pushed_HintInputs */

const vi_einvoice_pushed_hint = /** @type {(inputs: Einvoice_Pushed_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bước tiếp theo: mở Xem nháp để kiểm tra, sau đó chọn Xuất bản.`)
};

/**

* @param {Einvoice_Pushed_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_pushed_hint = /** @type {((inputs?: Einvoice_Pushed_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Pushed_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_pushed_hint(inputs)
});